import Axis from './Axis';
import AxisTitle from './AxisTitle';
var ChartAxis = Axis;
ChartAxis.Title = AxisTitle;
export default ChartAxis;